import React from "react";
import Modal from "react-modal";
import "../../../../css/modal.css";
import { useSelector, useDispatch } from "react-redux";
import { setError } from "../../redux/reducers/fabricSlice";
Modal.setAppElement(document.getElementById("threekit-root"));

export default function ModalAlert() {
  const dispatch = useDispatch();
  const { active, message } = useSelector((state) => state.fabric.error);
  const clearError = () => dispatch(setError({ active: false, message: "" }));

  return (
    <Modal className="alert-modal" isOpen={active} contentLabel="Error Modal">
      <div className="alert-title">
        <h3>Error</h3>
        <button className="close-btn" onClick={() => clearError()}>
          <i className="fa fa-times"></i>
        </button>
      </div>
      <div className="alert-content">
        <p>{message}</p>
      </div>
    </Modal>
  );
}
